/**
 * LeaveMessageModule functionality.
 * @author Dayne Coulson-Hoffacker
 */

export default class LeaveMessageModule {
/**
   * Constructs a new LeaveMessageModule instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */

  constructor(options) {
		this.element = options.element
    this.toggle = this.element.querySelector('[data-component="open-close-toggle"]')
    this.globalToggles = document.querySelectorAll('[data-component="leave-a-message-toggle"]')
    this.phoneToggles = document.querySelectorAll('[data-component="phone"]')
    this.closeLeaveMessageModule = this.element.querySelector('[data-component="close-leave-message-module"]')

    this.closeLeaveMessageModule.addEventListener('click', () => {
      document.body.classList.remove('leave-message-module-open')
      document.body.style.overflow = 'auto'
      this.element.classList.remove('visible')
    })
    
    this.toggle.addEventListener('click', () => {
      if (this.element.classList.contains('visible')) {
        document.body.classList.remove('leave-message-module-open')
        document.body.style.overflow = 'auto'
        this.element.classList.remove('visible')
      } else {
        document.body.classList.add('leave-message-module-open')
        document.body.style.overflow = 'hidden'
        this.element.classList.add('visible')
      }
    })

    this.phoneToggles.forEach(phoneToggle => {
      phoneToggle.addEventListener('click', (e) => {
        e.preventDefault()
        document.body.classList.toggle('leave-message-module-open')
        this.element.classList.toggle('visible')
      })
    })

    this.globalToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        document.body.classList.toggle('leave-message-module-open')
        this.element.classList.toggle('visible')
      })
    })

  }
}
